import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-status-warning-solid",
  "use": "icon-status-warning-solid-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-status-warning-solid\"><path d=\"M16 4c.554 0 1.278.34 1.7.865l.1.135 10.8 20c.58 1.352-.146 2.89-1.637 2.994L26.8 28H5.2c-1.352 0-2.33-1.492-1.856-2.855L3.4 25 14.2 5c.4-.6 1.2-1 1.8-1m1 18h-2v2h2zm0-9h-2v7h2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol